type InviteCardView = "accepted" | "federatedPending" | "federatedStart" | "passwordForm";

type ResolveInviteCardViewInput = {
  hasContinueAction: boolean;
  isAwaitingFederatedLogin: boolean;
  isFederated: boolean;
  federatedStartUrl: string | null;
};

export function resolveInviteCardView({
  hasContinueAction,
  isAwaitingFederatedLogin,
  isFederated,
  federatedStartUrl,
}: ResolveInviteCardViewInput): InviteCardView {
  if (hasContinueAction) {
    return "accepted";
  }

  if (isAwaitingFederatedLogin) {
    return "federatedPending";
  }

  if (!isFederated) {
    return "passwordForm";
  }

  return federatedStartUrl === null ? "federatedPending" : "federatedStart";
}
